module.exports = __webpack_public_path__ + "static/media/purpleFile.ec76550f.svg";